var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({class:_vm.svgClass,style:({opacity:_vm.opacity,fill:_vm.fill,width:_vm.width+'px',height:_vm.height+'px'}),attrs:{"aria-hidden":"true"}},_vm.$listeners),[_c('use',{attrs:{"xlink:href":_vm.iconName,"x-link:title":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }